import { types } from "../types/types";

export const calendariReducer = (state = { loadingDetallMes: false }, action) => {

    switch (action.type){
    
        case types.calendariIncidenciaSemanaConsultada:
            return { ...state, llistatIncidenciaSemanaConsultada: action.llistatIncidenciaSemanaConsultada };

        case types.calendariFixatgesSemanaConsultada:
            return { ...state, llistatFixatgesSemanaConsultada: action.llistatFixatgesSemanaConsultada };

        case types.calendariVacancesMesConsultat:
            return { ...state, vacancesMesConsultat: action.vacancesMesConsultat };

        case types.calendariVacancesInfo:
            return { ...state, vacancesInfo: action.vacancesInfo };

        case types.calendariIniciMesConsultat:
            return { ...state, inici: action.inici };

        case types.calendariFinalMesConsultat:
            return { ...state, final: action.final };

        // NOU: detall mes complet (1 crida)
        case types.calendariDetallMesLoading:
            return { ...state, loadingDetallMes: true, detallMes: null };

        case types.calendariDetallMesComplet:
            return { ...state, loadingDetallMes: false, detallMes: action.detallMes };

        case types.calendariDetallMesReset:
            return { ...state, loadingDetallMes: false, detallMes: null };

        default:
            return state;
    }
}